import { render, staticRenderFns } from "./StudentReferralEvaluations.vue?vue&type=template&id=3f9d2e5c&"
import script from "./StudentReferralEvaluations.vue?vue&type=script&lang=js&"
export * from "./StudentReferralEvaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports